import React, { useRef } from 'react';
import { Grid, makeStyles, IconButton, FormHelperText } from '@material-ui/core';
import externalLinkIcon from 'core/assets/svg/external-link.svg';
import { getIn } from 'formik';

import { Button } from 'core/components/button';
import { Label } from 'core/components/label';

const useStyles = makeStyles((theme) => ({
  uploadButton: {
    marginBottom: 20,
    marginRight: 10
  },
  templateButton: {
    color: theme.colors.light_text,
    fontSize: 14
  }
}));

const File = ({
  field: { id, name, label, mode, value, optional, onChange: customOnChange, ...props },
  ctx: { setFieldTouched, setFieldValue, errors }
}) => {
  const fileRef = useRef(null);
  const classes = useStyles();
  const error = getIn(errors, name);

  return (
    <>
      <input
        ref={fileRef}
        id="file-upload"
        name="tool-file-upload"
        type="file"
        style={{ display: 'none' }}
        accept=".csv"
        onChange={({ target }) => {
          setFieldTouched(name, true, false);
          setFieldValue(name, target.files[0]);
        }}
      />
      <Grid container alignItems="center">
        <Button
          onClick={() => fileRef.current.click()}
          variant="contained"
          color="primary"
          className={classes.uploadButton}
        >
          Upload
        </Button>

        <Label type="toolDescription">
          <Grid container alignItems="center">
            {value ? `${value.name}` : 'No file selected'}
            {props.templateUrl && !value && (
              <IconButton
                onClick={(event) => {
                  event.stopPropagation();
                  window.open(props.templateUrl, '_blank');
                }}
                className={classes.templateButton}
              >
                {' |   '}
                <img src={externalLinkIcon} alt="edit" />
                Start with a template
              </IconButton>
            )}
          </Grid>
        </Label>
      </Grid>
      {error && (
        <FormHelperText classes={{ root: classes.helperText }} id={id} error>
          {error}
        </FormHelperText>
      )}
    </>
  );
};

export default File;
